module.exports = __webpack_public_path__ + "img/TUSD.11e7d49f.svg";